import { createFileRoute } from "@tanstack/react-router"
import { NewLiveEventPage } from "@/features/live-events-admin/config/NewLiveEventPage"

export const Route = createFileRoute("/live-events/new")({
	component: NewLiveEventPage,
	validateSearch: (search: Record<string, unknown>): { from?: string } =>
		typeof search.from === "string" && search.from ? { from: search.from } : {},
})
